module.exports = __webpack_public_path__ + "static/media/curator_outro_spritesheet.af10022e.png";